import React from 'react';
import { showPendingContentBtn } from '../../../services/campaignManager';
import { useTranslation, Trans } from 'react-i18next';
import { Button, Icon, Tooltip } from 'antd';

const PendingContentButton = ({
  editCampaignActive,
  currentCampaign,
  creationType,
  user,
  onClick,
  isPendingContent
}) => {
  const { t } = useTranslation();

  return (
    showPendingContentBtn({ editCampaignActive, currentCampaign, creationType, user }) && (
      <Tooltip
        title={
          isPendingContent ? (
            <Trans i18nKey="Pending ad" components={{ strong: <strong />, br: <br /> }} />
          ) : (
            <Trans i18nKey="I don't have my ads" components={{ strong: <strong />, br: <br /> }} />
          )
        }
      >
        <Button
          className="buttonActionsDisplayGroup"
          shape="circle"
          type={isPendingContent ? 'primary' : 'ghost'}
          onClick={onClick}
        >
          <Icon type={'clock-circle'} />
        </Button>
      </Tooltip>
    )
  );
};

export default PendingContentButton;
